export default "__VITE_ASSET__uIxCsz8M__"